// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import api from './service/api'
import func from './assets/js/func'
import Mixin from './mixins'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import Vant from 'vant';
import 'vant/lib/index.css';
import VideoPlayer from "vue-video-player"
import moment from 'moment'
import BaiduMap from 'vue-baidu-map'
// window.oss = oss
// import 'vue-video-player/src/index'
// import 'vue-video-player/dist/'

Vue.use(Vant);
// Vue.use(Oss);
Vue.use(BaiduMap, {
        ak: 'FmqjQnG76dTLr5yNvWBZaHoFo5nuzTWj'
    })
    //公用组件
import GHeader from './components/header.vue'
import GUnit from './components/unitList.vue'
import PositionToast from './components/PositionToast.vue'
import GTime from './components/timer.vue'
import ViewImg from './components/viewImg'
import md5 from 'js-md5';
// import VueHtml5Editor from './assets/js/htmlEditor'
// import 'font-awesome/css/font-awesome.css' //引入样式  需要单独下载

// Vue.use(VueHtml5Editor)
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import './assets/css/reset.css'

Vue.config.productionTip = false;
Vue.mixin(Mixin);
Vue.use(MintUI);
Vue.use(VideoPlayer);

import ECharts from 'vue-echarts'
import 'echarts/lib/chart/pie'

Vue.component('chart', ECharts)
Vue.prototype.$api = api;
Vue.prototype.$func = func;
Vue.prototype.$token = null;
Vue.prototype.$md5 = md5;
Vue.prototype.$moment = moment;
// Vue.prototype.$oss = oss;
moment.locale('zh-cn');
Vue.prototype.$plat = func.plat(); //判断当前平台

NProgress.configure({
    easing: 'ease', // 动画方式    
    speed: 500, // 递增进度条的速度    
    showSpinner: false,
    trickleSpeed: 200, // 自动递增间隔    
    minimum: .1 // 初始化时的最小百分比
})


const components = [
    GHeader,
    GUnit,
    PositionToast,
    GTime,
    ViewImg
];
//全局组件注册
components.map(component => {
    Vue.component(component.name, component);
});


/* eslint-disable no-new */
export const eventBus = new Vue()
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// router.beforeEach((to, from , next) => {
//   NProgress.start();
//   next();
// });

// router.afterEach(() => {  
//   NProgress.done()
// })


// WEBPACK FOOTER //
// ./src/main.js